// extracted by mini-css-extract-plugin
module.exports = {"disabled":"BuildTextarea_disabled__Xs65_","disabled__value":"BuildTextarea_disabled__value__K6NRb"};